import { Group, callAccountGroups } from '@/api'
import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'

import { createHierarchy } from './createHierarchy'
import { recursivelyEnrichGroups } from './recursivelyEnrichGroups'
import type { GroupWithUserData, HierarchisedGroups } from './types'

const useHierarchisedGroups = (): HierarchisedGroups => {
  const { isLoading: isGroupLoading, data: groupData } = useQuery({
    queryKey: ['hierarchisedGroups'],
    queryFn: async () => {
      const response = await callAccountGroups()

      const hierarchyObject = createHierarchy(response.data as Group[])

      const enrichedGroupData: GroupWithUserData[] = []

      for (const group of hierarchyObject) {
        enrichedGroupData.push(await recursivelyEnrichGroups(group))
      }

      return enrichedGroupData
    },
  })

  const hierarchisedGroups = useMemo(() => groupData ?? [], [groupData])

  return {
    hierarchisedGroups,
    isLoading: isGroupLoading,
  }
}

export default useHierarchisedGroups
